import React, { useContext, useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import { AuthContext } from "../../App";
import * as apiAuth from "../../api/apiAuth.js"
import * as Auth from "../Login/Auth.js"
import { Loading } from '../Loading';
import { ReqLogin, UserInfo } from '../../item/ItemAccount';
import { api_getCompanyInfo } from '../../api/apiCompany';
import { loginPageInfo } from '../../config';

export function Login() {
  //const [authState] = useContext(AuthContext);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [isSend, setIsSend] = useState(false)

  const [texIdNumber, setTexIdNumber] = useState("")
  const [companyName, setCompanyName] = useState("")

  /*
  const constWord = {
    inputID : "請輸入帳號(Email)",
    forgetPw : "忘記密碼？",
    resetPw : "重設密碼",
    forgetPwText : "請輸入您註冊之Email，系統將會發送重設密碼信給您",
    copyright : "© 2019 大豐環保科技 All rights reserved"
  }
  */

  useEffect(() => {
    var pathArray = window.location.pathname.split("/").slice(1)
    if (pathArray[1] !== undefined) {
      setTexIdNumber(pathArray[1])
    }
  }, []);

  useEffect(() => {
    if (texIdNumber !== "") {
      setIsLoading(true)
      api_getCompanyInfo({
        texIdNumber,
        success: (jsonData) => {
          console.log(jsonData)
          if (jsonData.info === undefined) {
            setCompanyName('無此資料')
          } else {
            setCompanyName(jsonData.info.companyName + loginPageInfo.getTestString())
          }
          setIsLoading(false)
        },
        failure: (err) => {
          console.log(err)
          setIsLoading(false)
        }
      })
    } else {
      setCompanyName(loginPageInfo.getCompanyName())
    }
  }, [texIdNumber])

  function toLogin(event) {
    var mReqLogin = new ReqLogin({
      account: userId,
      password,
      texIdNumber
    })
    if (mReqLogin.account === "" || mReqLogin.password === "") {
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: '不得為空值',
      })
    } else {
      event.preventDefault();
      if (!isSend) {
        setIsSend(true)
        setIsLoading(true)
        apiAuth.toLogin({
          mReqLogin,
          success: (obj) => {
            setIsLoading(false)
            console.log(obj.userInfo)
            var mUserInfo = new UserInfo({})
            mUserInfo.fromJson(obj.userInfo)
            if(mUserInfo.isDisable){
              Swal.fire({
                type: 'error',
                title: '提醒',
                text: '此帳戶已被停用',
              })
            }else if(mUserInfo.companyIsDisable){
              Swal.fire({
                type: 'error',
                title: '提醒',
                text: '此公司已被停用',
              })
            }else{
              Auth.setToken(obj.token);
              Auth.setUserInfo(mUserInfo)
              Auth.setTexIdNumber(mReqLogin.texIdNumber)
              Auth.setLogin(true);
              window.location.replace("/main");
            }
          },
          failure: () => {
            setIsLoading(false)
            Swal.fire({
              type: 'error',
              title: '提醒',
              text: '登入失敗',
            }).then(() => {
              setIsSend(false)
            })
          }
        });
      }
    }
  }
  //忘記密碼
  /*
  async function toForgetPw () {
    const {value: email} = await Swal.fire({
      title: constWord.forgetPw,
      text: constWord.forgetPwText,
      input: 'email',
      inputPlaceholder: constWord.inputID,
      confirmButtonColor: '#1ab394',
      confirmButtonclassName: 'block full-width m-b',
      confirmButtonText: constWord.resetPw
    })
    
    if (email) {

      Swal.fire({
        type: 'success',
        title: '提醒',
        text: '請至Email信箱收取重設密碼信!',
        confirmButtonColor: '#1ab394',
        confirmButtonclassName: 'block full-width m-b',
        confirmButtonText: "我知道了"
      })
    }
  }
  */

  return (

    <div className="middle-box text-center loginscreen animated fadeInDown">
      <Loading isLoading={isLoading} />
      <div>
        <div>

          <h2 className="logo-name">{loginPageInfo.getLogo()}</h2>

        </div>
        <h2><b>{companyName}</b></h2>
        <p>登入系統</p>
        <form className="m-t" onSubmit={toLogin}>
          <div className="form-group">
            <input type="tel" className="form-control" placeholder="手機號碼" required="" value={userId} onChange={e => setUserId(e.target.value)} />
          </div>
          <div className="form-group">
            <input type="password" className="form-control" placeholder="密碼" required="" value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          <button type="submit" className="btn btn-primary block full-width m-b">Login</button>
          {/**
              <a href="#"><small>Forgot password?</small></a>
                */}
          {/* <p className="text-muted text-center"><small>Do not have an account?</small></p>
          <a className="btn btn-sm btn-white btn-block" href="register.html">Create an account</a> */}
        </form>
        <p className="m-t"> <small>Inspinia we app framework base on Bootstrap 3 &copy; 2014</small> </p>
      </div>



      {/**
    <div className="login-box">
  <div className="login-logo">
  <b>人力派遣</b>
  </div>
  <div className="login-box-body">
    <p className="login-box-msg">登入系統</p>

    <form className="m-t" onSubmit={toLogin}>
      <div className="form-group has-feedback">
        <input type="tel" className="form-control" placeholder="手機號碼" onChange={e=>setUserId(e.target.value)} />
        <span className="glyphicon glyphicon glyphicon-phone form-control-feedback"></span>
      </div>
      <div className="form-group has-feedback">
        <input type="password" className="form-control" placeholder="密碼" onChange={e=>setPassword(e.target.value)} />
        <span className="glyphicon glyphicon-lock form-control-feedback"></span>
      </div>
      <div className="row">
        <div className="col-xs-8">
        </div>
        <div className="col-xs-4">
          <button type="submit" className="btn btn-primary btn-block btn-flat">Sign In</button>
        </div>
      </div>
    </form>

  </div>
</div>
     */}
    </div>

  )
}